import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { FaSpinner } from 'react-icons/fa';
import Modal from '../common/Modal';
import { updateProfile } from '../../store/authSlice';
import { validateDob } from '../../utils/userNeedsDob';

const DobCollectionModal = ({ show }) => {
  const dispatch = useDispatch();
  const [dob, setDob] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationError = validateDob(dob);
    if (validationError) {
      setError(validationError);
      return;
    }

    setError('');
    setIsSubmitting(true);

    try {
      await dispatch(updateProfile({ dob })).unwrap();
    } catch (err) {
      setError(typeof err === 'string' ? err : 'Failed to save date of birth. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={show}
      title="Complete your profile"
      size="md"
      hideClose
      preventClose
      footer={
        <button
          type="submit"
          form="dob-collection-form"
          disabled={isSubmitting}
          className="btn-primary min-w-[120px] disabled:opacity-50"
        >
          {isSubmitting ? (
            <>
              <FaSpinner className="animate-spin" aria-hidden />
              Saving…
            </>
          ) : (
            'Continue'
          )}
        </button>
      }
    >
      <p className="text-sm text-text-secondary mb-5">
        We need your date of birth to finish setting up your account. This is required before you can continue.
      </p>

      <form id="dob-collection-form" onSubmit={handleSubmit} noValidate>
        <label
          htmlFor="post-login-dob"
          className="block text-xs font-semibold text-gray-700 mb-1.5 uppercase tracking-wide"
        >
          Date of birth
        </label>
        <input
          id="post-login-dob"
          name="dob"
          type="date"
          value={dob}
          onChange={(e) => {
            setDob(e.target.value);
            if (error) setError('');
          }}
          required
          disabled={isSubmitting}
          className="form-input w-full"
          aria-invalid={error ? 'true' : 'false'}
        />
        {error && (
          <p className="mt-2 text-xs text-red-500 font-medium" role="alert">
            {error}
          </p>
        )}
      </form>
    </Modal>
  );
};

export default DobCollectionModal;
